/**
 * How a requested item reads on screen: "Group: Item" when it was asked
 * under a group (a "yes" question is named after its group, so just the
 * name), with the detail after a dash.
 */
export const itemLabel = (item) =>
  item?.group && item.group !== item.name ? `${item.group}: ${item.name}` : item?.name || '';

export const itemLine = (item) =>
  item?.detail ? `${itemLabel(item)} — ${item.detail}` : itemLabel(item);

/** "Službeni mejl: NE · Već ima računar: DA" for a request's yes / no answers. */
export const answersLine = (answers, tn) =>
  (answers || [])
    .map((answer) => `${answer.group}: ${tn(answer.value === 'yes' ? 'answerYes' : 'answerNo')}`)
    .join(' · ');
